import { useApp } from "../context/AppContext";
import PRODUCTS, { NEW_ARRIVAL_IDS } from "../data/products";
import CATEGORIES from "../data/categories";
import Breadcrumb  from "../components/Breadcrumb";
import ProductGrid from "../components/ProductGrid";

export default function ProductsPage() {
  const { activeCat, search } = useApp();

  // ── Filter products ──────────────────────────────────────
  const filtered = PRODUCTS.filter((product) => {
    const matchesCat =
      activeCat === "all" ? true :
      activeCat === "new" ? NEW_ARRIVAL_IDS.includes(product.id) :
      product.cat === activeCat;

    const query = search.toLowerCase();
    const matchesSearch =
      !query ||
      product.name.toLowerCase().includes(query) ||
      product.desc.toLowerCase().includes(query);

    return matchesCat && matchesSearch;
  });

  // ── Metadata for current category ───────────────────────
  const catInfo = CATEGORIES.find((c) => c.id === activeCat) ?? CATEGORIES[0];

  // ── Breadcrumb crumbs ────────────────────────────────────
  const crumbs = [
    { label: "Home", page: "home" },
    { label: "Products", page: "products" },
    ...(activeCat !== "all" ? [{ label: catInfo.label }] : []),
  ];

  return (
    <div className="page-wrap fade-up">
      <Breadcrumb crumbs={crumbs} />

      {/* Page title */}
      <div className="page-title-row">
        <span className="page-title-icon">{catInfo.icon}</span>
        <h1 className="page-title">{catInfo.label}</h1>
        <span className="page-count">{filtered.length} items</span>
      </div>

      <ProductGrid products={filtered} />
    </div>
  );
}
